<template>
  <!-- 对齐 App about_us.dart：AppHeader（无标题）+ 白色 Card（顶部圆角 30 + 10.w 上边距）+ logo + 介绍文字 + 官网 + 社交媒体 + 两个链接卡 -->
  <div class="about-page">
    <app-header></app-header>

    <div class="about-card">
      <div class="about-scroll">
        <!-- Logo (App: images/logo.png 272.w) -->
        <div class="about-logo">
          <img class="about-logo-img" src="../assets/imgs/logo.png" alt="" />
        </div>

        <!-- 公司介绍 -->
        <div class="about-content">{{ i18n.content }}</div>

        <!-- 官网 (At + 可点击链接) -->
        <div class="about-website">
          <div class="about-website-at">{{ i18n.at }}</div>
          <div class="about-website-link" @click="onWebsite">
            {{ websiteText }}
          </div>
        </div>

        <!-- 社交媒体 -->
        <div class="about-social-title">{{ i18n.social_media }}</div>
        <div class="about-social-row">
          <img
            class="about-social-icon"
            src="../assets/imgs/icon_twitter_symbol.png"
            alt=""
            @click="onSocial('twitter')"
          />
          <img
            class="about-social-icon"
            src="../assets/imgs/icon_tiktok_symbol.png"
            alt=""
            @click="onSocial('tiktok')"
          />
          <img
            class="about-social-icon"
            src="../assets/imgs/icon_instagram_symbol.png"
            alt=""
            @click="onSocial('instagram')"
          />
          <img
            class="about-social-icon"
            src="../assets/imgs/icon_facebook_symbol.png"
            alt=""
            @click="onSocial('facebook')"
          />
          <img
            class="about-social-icon"
            src="../assets/imgs/icon_youtube_symbol.png"
            alt=""
            @click="onSocial('youtube')"
          />
        </div>

        <!-- 用户协议卡 -->
        <div class="about-link-card" @click="onUserAgreement">
          {{ i18n.user_agreement }}
        </div>

        <!-- 隐私政策卡 -->
        <div class="about-link-card" @click="onPrivacyPolicy">
          {{ i18n.privacy_policy }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from "../components/common/AppHeader.vue"

export default {
  components: {
    AppHeader
  },
  computed: {
    i18n() {
      return this.$t("about")
    },
    // 对齐 App about_us.dart L145：Global.website.replaceAll("https://", "")
    websiteText() {
      const domain = process.env.VUE_APP_DOMAIN || "https://m.powerdot.com.ng"
      return domain.replace(/^https?:\/\//, "")
    }
  },
  methods: {
    onWebsite() {
      const url = process.env.VUE_APP_DOMAIN || "https://m.powerdot.com.ng"
      window.open(url)
    },
    onSocial(key) {
      // 对齐 App about_us.dart：launch(...)
      const map = {
        twitter: "https://x.com/",
        tiktok: "https://www.tiktok.com/",
        instagram: "https://www.instagram.com/",
        facebook: "https://www.facebook.com/",
        youtube: "https://www.youtube.com/"
      }
      const url = map[key]
      if (url) window.open(url)
    },
    onUserAgreement() {
      const url = `${process.env.VUE_APP_DOMAIN}/content/user_agreement.html`
      window.open(url)
    },
    onPrivacyPolicy() {
      const url = `${process.env.VUE_APP_DOMAIN}/content/privacy_policy.html`
      window.open(url)
    }
  }
}
</script>

<style lang="less">
/* 对齐 App about_us.dart：白底 page + 白色 Card（顶部圆角 30 + 10.w 上边距） */
.about-page {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background: #fff;
  display: flex;
  flex-direction: column;
}

.about-card {
  flex: 1;
  background: #fff;
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;
  margin-top: 17px;
  overflow: hidden;
}

.about-scroll {
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 70px 0 80px;
  box-sizing: border-box;
}

.about-logo {
  width: 100%;
  display: flex;
  justify-content: center;
}

.about-logo-img {
  width: 476px; /* 272.w ≈ 476px */
  height: auto;
  display: block;
  object-fit: contain;
}

.about-content {
  margin: 60px 70px 35px;
  font-size: 32px; /* 18.sp ≈ 32px */
  color: #000;
  line-height: 1.5;
  text-align: center;
}

.about-website {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.about-website-at {
  font-size: 28px; /* 16.sp */
  color: #000;
  line-height: 1.4;
}

.about-website-link {
  font-size: 28px;
  color: #000;
  font-family: "Montserrat-SemiBold", sans-serif;
  text-decoration: underline;
  line-height: 1.4;
  cursor: pointer;
}

.about-social-title {
  margin-top: 50px;
  font-size: 28px;
  color: #000;
  text-align: center;
}

.about-social-row {
  margin-top: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.about-social-icon {
  width: 56px;
  height: 56px;
  margin: 0 25px;
  display: block;
  cursor: pointer;
}

.about-link-card {
  width: calc(100% - 90px);
  margin-top: 70px; /* 60.w */
  padding: 18px 30px;
  min-height: 115px; /* 66.w */
  background: #f8f6fc;
  border: 1px solid #f8f6fc;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px; /* 18.sp */
  color: #000;
  font-family: "Montserrat-SemiBold", sans-serif;
  text-align: center;
  box-sizing: border-box;
  cursor: pointer;
}
</style>
